<template>
    <DModal
        :title="__('customers.contracts.change_plesk_server.change_plesk_server')"
        :is-confirm="true"
        :show="show"
        :is-awaiting-validation="true"
        @confirm="changePleskServerSubmit"
        @close="$emit('close-modal')"
    >
        <DFieldLoading
            v-if="isLoading"
            :is-loading="isLoading"
            is-big
            class="my-4 d-flex justify-content-center"
        />
        <div
            v-else
            role="group"
            class="p-3"
        >
            <DForm
                @submit.prevent="changePleskServerSubmit"
            >
                <DFormRow
                    :label="__('customers.contracts.change_plesk_server.servergroup')"
                    :is-required="true"
                    :error="errors.note"
                >
                    <DSelect
                        id="fulfillment_account_group"
                        v-model="form.serverGroup"
                        :options="fulfillmentAccountGroupOptions"
                        :clearable="false"
                        :placeholder="__('customers.customers.select_server_group')"
                        :is-valid="isFormFieldValid('server_group')"
                        @update:value="handleGroupChange"
                    />
                </DFormRow>
                <DFormRow
                    :label="__('customers.contracts.change_plesk_server.server')"
                    :is-required="true"
                    :error="errors.note"
                >
                    <DSelect
                        id="fulfillment_account"
                        v-model="form.server"
                        :options="fulfillmentAccountOptions"
                        :placeholder="__('customers.customers.select_server')"
                        :is-valid="isFormFieldValid('server')"
                    />
                </DFormRow>
                <DFormRow
                    :label="__('customers.contracts.change_plesk_server.domain')"
                    :is-required="false"
                    :error="errors.note"
                >
                    <DInput
                        id="domain"
                        v-model="form.domain"
                        :is-valid="isFormFieldValid('domain')"
                        type="text"
                    />
                </DFormRow>
                <DFormRow
                    :label="__('customers.contracts.change_plesk_server.username')"
                    :is-required="false"
                    :error="errors.note"
                >
                    <DInput
                        id="username"
                        v-model="form.username"
                        :is-valid="isFormFieldValid('username')"
                        type="text"
                    />
                </DFormRow>
                <DFormRow
                    :label="__('customers.contracts.change_plesk_server.external_id')"
                    :is-required="false"
                    :error="errors.note"
                >
                    <DInput
                        id="external_id"
                        v-model="form.external_id"
                        :is-valid="isFormFieldValid('external_id')"
                        type="text"
                    />
                </DFormRow>
            </DForm>
        </div>
    </DModal>
</template>

<script>
import DFieldLoading from '~@/Components/Common/DFieldLoading'

export default {
    name: 'ChangePleskServerForm',
    components: { DFieldLoading },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        contract: {
            type: Object,
            default: () => { return {} }
        },
        fulfillmentAccount: {
            type: Object,
            default: () => { return {} }
        },
        errorsData: {
            type: Object,
            default: () => { return {} }
        },
        disabled: {
            type: Boolean,
            default: () => true
        }
    },
    emits: ['close-modal'],

    data () {
        return {
            form: this.$inertia.form({
                serverGroup: this.fulfillmentAccount?.group_id ?? null,
                server: this.fulfillmentAccount?.id ?? null,
                domain: this.getDomain(),
                username: this.getUsername(),
                external_id: this.contract?.external_id ?? null
            }),
            errors: this.errorsData,
            modalHasErrors: false,
            isLoading: true,
            fulfillmentAccountGroups: []
        }
    },
    computed: {
        fulfillmentAccountGroupOptions () {
            return this.fulfillmentAccountGroups.map(group => {
                return {
                    value: group.id,
                    label: group.name
                }
            })
        },
        fulfillmentAccountOptions () {
            if (this.form.serverGroup === null) {
                return []
            }

            const group = this.fulfillmentAccountGroups.find((group) => Number(group.id) === Number(this.form.serverGroup))

            if (!group) {
                return []
            }

            return group
                .accounts
                .map(account => {
                    return {
                        value: account.id,
                        label: account.name
                    }
                })
        }
    },
    created () {
        window.axios.get(this.$route('customers.customers.contracts.plesk-fulfillment-account-groups', {
            customer: this.contract.customer_id
        }))
            .then(response => {
                this.fulfillmentAccountGroups = response.data.fulfillmentAccountGroups
                this.isLoading = false
            })
    },
    methods: {
        handleGroupChange () {
            this.form.server = null
        },
        changePleskServerSubmit () {
            this.form.post(this.$route('customers.customers.contracts.change-plesk-server', {
                customer: this.contract.customer_id,
                contract: this.contract.id
            }), {
                onSuccess: () => {
                    this.$emit('close-modal')
                    this.modalHasErrors = false
                },
                onError: (error) => {
                    this.errors = error
                    this.modalHasErrors = true
                }
            })
        },
        getUsername () {
            for (const config of this.contract.fulfillment_contract_config_values) {
                if (config.key === 'username') {
                    return config.value
                }
            }

            return null
        },
        getDomain () {
            for (const config of this.contract.fulfillment_contract_config_values) {
                if (config.key === 'domain') {
                    return config.value
                }
            }

            return null
        }
    }
}
</script>
